var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1F1F91F1F7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30A17",
    d: "M8,195.25 C178.83,110.03 349.03,140.83 521.26,167.28 C676.47,191.12 833.42,211.85 992,132.75 L992,804.75 C821.17,889.97 650.97,859.17 478.74,832.72 C323.53,808.88 166.58,788.15 8,867.25 L8,195.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M520.5,503.17 C520.21,597.26 447.33,657.2 356.5,648.45 C265.68,639.2 192.78,570.56 192.5,478.62 C192.79,384.57 265.66,303.77 356.5,312.45 C447.3,321.77 520.22,411.26 520.5,503.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E30A17",
    d: "M528.7,504.42 C528.42,579.41 470.21,628.42 397.5,619.5 C324.82,610.05 266.58,549.24 266.3,475.33 C266.58,400.36 324.78,341.82 397.5,350.7 C470.17,360.2 528.42,430.52 528.7,504.42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M486.33,497.89 C535.28,521.73 584.24,545.88 634.67,568.02 L542.99,426.7 L542.99,586.47 L634.67,469.27 C585.72,480.37 536.77,488.88 486.33,497.89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    opacity: 0.2,
    d: "M8,195.25 C178.83,110.03 349.03,140.83 521.26,167.28 C676.47,191.12 833.42,211.85 992,132.75 L992,804.75 C821.17,889.97 650.97,859.17 478.74,832.72 C323.53,808.88 166.58,788.15 8,867.25 L8,195.25 M39.25,214.64 L39.25,819.14 C345.81,690.88 650.43,915.18 960.75,785.36 L960.75,180.86 C654.19,309.12 349.57,84.82 39.25,214.64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F1F91F1F7);
export default __webpack_public_path__ + "static/media/1f1f9-1f1f7.b01b5cdfb5a968476ae71e2aa99a55f2.svg";
export { ForwardRef as ReactComponent };